// Single source for the MOCK ("demo") environment scoping. `is_demo` is the
// environment marker: mock rows are `is_demo = true`, normal rows `false`
// (account: profiles.is_demo; resource: tours/tap_venues.is_demo). Centralizing
// the include/exclude decision here keeps normal working surfaces from leaking
// mock data. See CLAUDE.md "Ambientes mock/normal".

export const MOCK_EMAIL = "mock@andarlabs.com";

/** A profile that belongs to the MOCK environment (the demo account). */
export const isMockProfile = (
  p?: { is_demo?: boolean | null } | null,
): boolean => p?.is_demo === true;

/** A resource (tour/venue) that belongs to the MOCK environment. */
export const isMockResource = (
  r?: { is_demo?: boolean | null } | null,
): boolean => r?.is_demo === true;

// --- Supabase query-builder scoping ------------------------------------------
// Generic over any PostgrestFilterBuilder-like object (chainable `.or` / `.eq`
// returning the same builder), so the same rule applies to every table.

interface OrFilter<T> {
  or(filter: string): T;
}
interface EqFilter<T> {
  eq(column: string, value: unknown): T;
}

/**
 * NORMAL aggregate view (admin/owner looking at a list of resources): keep the
 * caller's OWN rows, drop OTHER owners' demo rows. `ownerCol` = "user_id" for
 * tours, "owner_id" for venues.
 */
export function scopeNormalAggregate<T extends OrFilter<T>>(
  query: T,
  ownerCol: string,
  ownId: string,
): T {
  return query.or(`${ownerCol}.eq.${ownId},is_demo.eq.false`);
}

/**
 * Strict normal-only: drop ALL demo rows. Use for aggregates where the caller
 * has no own-demo rows to preserve (platform stats, cross-owner counts).
 */
export function excludeDemo<T extends EqFilter<T>>(query: T): T {
  return query.eq("is_demo", false);
}
